export default __webpack_public_path__ + "static/media/motorsports-home-image.31a5c3ee.png";